import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TooltipModule } from 'primeng/tooltip';
import { SubscriberCardComponent } from './subscriber-card.component';

@NgModule({
  declarations: [SubscriberCardComponent],
  imports: [CommonModule, RouterModule, TooltipModule],
  exports: [SubscriberCardComponent]
})
export class SubscriberCardModule {}
